import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthFacade } from '@ideapa/app-auth';

@Injectable({
  providedIn: 'root',
})
export class EnteGuard implements CanActivate {
  constructor(private authFacade: AuthFacade, private router: Router) {}

  canActivate(): Observable<boolean> {
    return this.authFacade.ente$.pipe(
      tap((ente) => {
        if (!ente) {
          this.router.navigateByUrl('/', { replaceUrl: true });
        }
      }),
      map((ente) => !!ente),
      first()
    );
  }
}
